import * as LearningModuleActions from "src/app/store/learning-module/actions";
import * as UserActions from "src/app/store/user/actions";
import * as FromLearningModule from "src/app/store/learning-module/selectors";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppRoutes } from "src/app/constants";
import { RootState } from "src/app/store";
import { LearningModuleDto } from "@api";
import { Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { IonRouterOutlet, ModalController, NavController } from "@ionic/angular";
import { IsModuleUnlockedPipe } from "src/app/pipes/is-module-unlocked/is-module-unlocked.pipe";
import { first } from "rxjs/operators";
import { ChallengeLockedPage } from "../../modals/challenge-locked/challenge-locked.page";

@Component({
  selector: "app-learning-modules",
  templateUrl: "./learning-modules.page.html",
  styleUrls: ["./learning-modules.page.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LearningModulesPage {
  public readonly routes: typeof AppRoutes = AppRoutes;
  public readonly breadcrumbs = [{ name: this.i18n.instant("DASHBOARD.BREADCRUMB_NAME"), link: `/${this.routes.home}` }];
  public readonly learningModules$: Observable<LearningModuleDto[]> = this.store.select(FromLearningModule.selectLearningModules);

  constructor(
    private readonly store: Store<RootState>,
    private readonly i18n: TranslateService,
    private readonly routerOutlet: IonRouterOutlet,
    private readonly navController: NavController,
    private readonly modalController: ModalController,
    private readonly isModuleUnlocked: IsModuleUnlockedPipe,
  ) {}

  public handleModuleClick(learningModule: LearningModuleDto): void {
    this.isModuleUnlocked
      .transform(learningModule.id)
      .pipe(first())
      .subscribe(isUnlocked => {
        if (isUnlocked) this.navController.navigateForward([AppRoutes.learningModules, learningModule.id]);
        else this.showLockedModal(learningModule);
      });
  }

  protected ionViewDidEnter(): void {
    this.store.dispatch(LearningModuleActions.getLearningModules());
    this.store.dispatch(UserActions.getUserModules());
  }

  private async showLockedModal(learningModule: LearningModuleDto): Promise<void> {
    const modal = await this.modalController.create({
      component: ChallengeLockedPage,
      componentProps: { learningModule },
      swipeToClose: true,
      backdropDismiss: true,
      presentingElement: this.routerOutlet.nativeEl,
      cssClass: ["challenge-locked-modal"],
    });

    await modal.present();
  }
}
